import * as React from 'react'

import List                 from '@material-ui/core/List'
import ListItem             from '@material-ui/core/ListItem'
import ListItemIcon         from '@material-ui/core/ListItemIcon/ListItemIcon'
import ListItemText         from '@material-ui/core/ListItemText/ListItemText'
import { FormattedMessage } from 'react-intl'
import {
  Link,
}                           from 'react-router-dom'
import styled               from 'styled-components'

import testingHooks from '../testing-hooks'
import { PrimitiveRoute } from '../types'

/*
 TODO:

 find a better way than this to handle hiding the underline on the
 anchor element. this is not the right place for a style
 */
const NavLink = styled(Link)`
  text-decoration: none;
`

/*
 TODO:

 answer the question whether it is ok to have this in the same file or not
 based on the answer change/move how you handle optionally showing the icon
 (hide HOC maybe?)
 */
const Icon = ({ icon }: { icon?: React.ReactElement<any> }) => {
  if (icon) {
    return (
      <ListItemIcon>
        {icon}
      </ListItemIcon>
    )
  }

  return null
}

interface Props {
  routes: PrimitiveRoute []
  prefix?: string
  onSelect?: () => void
}

export default ({
  routes,
  onSelect,
  prefix = '',
}: Props) => (
  <List component="nav">
    {routes.map(({ name, path, icon }: PrimitiveRoute) => (
      <NavLink
        key={prefix + path}
        to={prefix + path}
      >
        <ListItem
          data-test-id={testingHooks.drawerMenuListItem}
          button
          onClick={onSelect}
        >
          <Icon icon={icon}/>
          <ListItemText
            data-test-id={testingHooks.drawerMenuListItemText}
            inset
            primary={<FormattedMessage id={'routing.' + name}/>}
          />
        </ListItem>
      </NavLink>
    ))}
  </List>
)



// WEBPACK FOOTER //
// ./src/routing/DrawerList.tsx